import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../services/api";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Carousel styles
import "../css/Post.css";
import Header from '../components/Header';
import Nav from '../components/Nav';
import Footer from '../components/Footer';

const Post = () => {
  const { exploreId } = useParams(); // Get exploreId from URL
  const [post, setPost] = useState(null);
  const [images, setImages] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPostDetails = async () => {
      try {
        const response = await api.get(`/auth/getExploreById/${exploreId}`);
        setPost(response.data.body);
        setImages(
          response.data.imageList.filter((img) => img.images) // Filter valid images
        );
      } catch (err) {
        console.error("Error fetching post details:", err);
        setError("Failed to fetch post details.");
      }
    };

    fetchPostDetails();
  }, [exploreId]);

  if (error) return <p className="error-message">{error}</p>;
  if (!post) return <p>Loading...</p>;

  return (
    <div>
    <Header />
    <Nav />
    <div className="post-container">
      <div className="post-header">
        <h1>{post.exploreTitle}</h1>
        <p>Views: {post.viewCount} | Likes: {post.likeCount}</p>
      </div>
      <div className="post-carousel">
        {images.length > 0 ? (
          <Carousel
            showArrows
            showThumbs={false}
            autoPlay
            infiniteLoop
            dynamicHeight
          >
            {images.map((img) => (
              <div key={img.id}>
                <img src={img.images} alt={`Post ${img.id}`} />
              </div>
            ))}
          </Carousel>
        ) : (
          <img src={post.exploreImages} alt={post.exploreTitle} />
        )}
      </div>
      <div className="post-content">
        <p>{post.exploreContent}</p>
      </div>
    </div>
    <Footer />
    </div>
  );
};

export default Post;
